























































































































































































































































































































import OrderSelfpickShowCode from './components/order_selfpick_show_code.vue'
import {
  apiBlindBoxOrderGetOrderUrl,
  apiGroupBuyingOrderDelete,
  apiGroupBuyingOrderPay,
  apiOrderBigOrderList,
  ApiOrderBigOrderListResponse,
  apiOrderOrderCancel,
  apiOrderOrderConfirm,
  apiOrderOrderDelayConfirm,
  apiOrderOrderDelete,
  apiOrderOrderPay,
  apiOrderOrderUrged,
} from '@/api'
import { asRequiredDeep, defaultIndexTo } from 'vtils'
import {
  DeliveryDialog as BoxDeliveryDialog,
  RefundDialog as BoxRefundDialog,
} from '../box/components'
import { computed, nextTick, ref } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useHandler, useQuery } from '@/hooks'
import { Dialog, Toast } from 'vant'
import {
  endOfYear,
  formatDate,
  startOfYear,
  subMonths,
  subYears,
} from 'vtils/date'
import { globalModel } from '@/model'
import { GroupBuyingUtils } from '../group_buying/utils'
import { navigateTo } from '@/router'
import { onPageVisibilityChange, submit, Track } from '@/utils'
import { RequiredDeep } from 'vtils/types'
import { useWaterfall } from '@/components'
import { wait } from 'vtils'

type OrderItem = RequiredDeep<ApiOrderBigOrderListResponse>['list'][0]

export default defineClassComponent(
  {
    components: {
      BoxDeliveryDialog,
      BoxRefundDialog,
      OrderSelfpickShowCode,
    },
  },
  ({ ctx }) =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '订单中心',
        }))

        const off = onPageVisibilityChange(visible => {
          if (visible) {
            off()
            submit(async $ => {
              $.start()
              await wait(1000)
              this.waterfall.checkRecord()
            })
          }
        })
      }

      loading = computed(() => false)

      query = useQuery<{
        type: number
      }>({
        type: {
          transformer: Number,
        },
      })

      keywordTemp = ref('')
      keyword = ref('')

      typeData = computed(() => [
        {
          label: '全部',
          value: 0,
        },
        {
          label: '待付款',
          value: 1,
        },
        {
          label: '待发货',
          value: 2,
        },
        {
          label: '待收货',
          value: 3,
        },
        {
          label: '待使用',
          value: 6,
        },
        {
          label: '盲盒',
          value: 11,
        },
        {
          label: '拼团',
          value: 12,
        },
        {
          label: '退款/售后',
          value: 10,
        },
      ])

      typeIndex = ref(
        defaultIndexTo(
          this.typeData.value.findIndex(
            item => item.value === this.query.type,
          ),
          0,
        ),
      )

      showFilter = ref(false)

      dateShortcuts = computed(() => [
        {
          label: '近1个月',
          value: [subMonths(new Date(), 1), new Date()],
        },
        {
          label: '近3个月',
          value: [subMonths(new Date(), 3), new Date()],
        },
        {
          label: '近6个月',
          value: [subMonths(new Date(), 6), new Date()],
        },
        {
          label: '今年',
          value: [startOfYear(new Date()), new Date()],
        },
        {
          label: new Date().getFullYear() - 1,
          value: [
            startOfYear(subYears(new Date(), 1)),
            endOfYear(subYears(new Date(), 1)),
          ],
        },
        {
          label: new Date().getFullYear() - 2,
          value: [
            startOfYear(subYears(new Date(), 2)),
            endOfYear(subYears(new Date(), 2)),
          ],
        },
      ])

      dateMin = ref(startOfYear(new Date(2021, 1, 1)))
      dateMax = ref(new Date())

      dateShortcutIndexTemp = ref(-1)
      dateCustomStartTemp = ref<Date>()
      dateCustomEndTemp = ref<Date>()

      dateShortcutIndex = ref(-1)
      dateCustomStart = ref<Date>()
      dateCustomEnd = ref<Date>()

      dateRange = computed(() => {
        return (
          this.dateShortcutIndex.value !== -1
            ? this.dateShortcuts.value[this.dateShortcutIndex.value].value
            : [this.dateCustomStart.value, this.dateCustomEnd.value].filter(
                Boolean,
              )
        ).map(date => formatDate(date!, 'yyyy-mm-dd'))
      })
      hasFilter = computed(() => !!this.dateRange.value.length)

      waterfall = useWaterfall<string>('waterfall')
      waterfallKey = computed(() =>
        [
          this.typeIndex.value,
          this.keyword.value,
          ...this.dateRange.value,
        ].join('_'),
      )

      boxOrder = ref<any>()
      showBoxRefundDialog = ref(false)
      showBoxDeliveryDialog = ref(false)

      currentOrder = ref<any>()

      handleServiceClick = useHandler<
        | '搜索关键词清空'
        | '搜索'
        | '筛选'
        | '筛选快捷时间点击'
        | '筛选起始时间输入'
        | '筛选终止时间输入'
        | '筛选重置'
        | '筛选确定'
        | '订单店铺点击'
        | '订单详情'
        | '售后详情'
        | '售后'
        | '订单操作'
      >({
        搜索关键词清空: () => {
          this.keywordTemp.value = ''
          this.handleServiceClick('搜索')
        },
        搜索: () => {
          this.keyword.value = this.keywordTemp.value
        },
        筛选: () => {
          if (this.showFilter.value) {
            this.showFilter.value = false
            return
          }
          this.dateShortcutIndexTemp.value = this.dateShortcutIndex.value
          this.dateCustomStartTemp.value = this.dateCustomStart.value
          this.dateCustomEndTemp.value = this.dateCustomEnd.value
          this.showFilter.value = true
        },
        筛选快捷时间点击: (index: number) => {
          this.dateShortcutIndexTemp.value = index
          this.dateCustomStartTemp.value = undefined
          this.dateCustomEndTemp.value = undefined
        },
        筛选起始时间输入: (date: Date) => {
          this.dateShortcutIndexTemp.value = -1
          this.dateCustomStartTemp.value = date
        },
        筛选终止时间输入: (date: Date) => {
          this.dateShortcutIndexTemp.value = -1
          this.dateCustomEndTemp.value = date
        },
        筛选重置: () => {
          this.dateShortcutIndexTemp.value = -1
          this.dateCustomStartTemp.value = undefined
          this.dateCustomEndTemp.value = undefined
        },
        筛选确定: () => {
          this.dateShortcutIndex.value = this.dateShortcutIndexTemp.value
          if (
            this.dateCustomStartTemp.value &&
            this.dateCustomEndTemp.value
          ) {
            this.dateCustomStart.value = this.dateCustomStartTemp.value
            this.dateCustomEnd.value = this.dateCustomEndTemp.value
          } else {
            this.dateCustomStart.value = undefined
            this.dateCustomEnd.value = undefined
          }
          this.showFilter.value = false
        },
        订单店铺点击: (order: OrderItem) => {
          if (order.merchantUrl) {
            dcb.navigateTo({
              url: order.merchantUrl,
            })
          }
        },
        订单详情: (order: OrderItem) => {
          if (order.url) {
            dcb.navigateTo({
              url: order.url,
            })
          }
        },
        售后: () => {
          Dialog.confirm({
            title: '温馨提示',
            message:
              '当前订单已经完结，不支持在线售后，相关问题可联系平台客服处理。',
            showCancelButton: false,
            confirmButtonText: '我知道了',
          })
        },
        售后详情: (orderOrGoods: { saleAfterId: string }) => {
          if (orderOrGoods.saleAfterId) {
            navigateTo('AfterSalesDetail', {
              id: orderOrGoods.saleAfterId,
            })
          }
        },
        订单操作: async (
          order: OrderItem,
          action: OrderItem['buttonList'][0],
        ) => {
          this.currentOrder.value = order

          if (action.url) {
            dcb.navigateTo({
              url: action.url,
            })
          } else {
            switch (action.type) {
              // 去支付
              case 1:
                await submit(async $ => {
                  await $.start()
                  const payData = await apiOrderOrderPay({
                    orderNo: order.orderNo,
                    payType: globalModel.state.payType as any,
                    openId: globalModel.state.openid,
                  })
                  await dcb.requestPayment({
                    provider: 'native',
                    showNativeResultPage: false,
                    params: payData,
                  })
                  await this.handleRefresh(order)
                  await $.success('支付成功')
                })
                break
              // 取消订单
              case 2:
                await submit(async $ => {
                  await Dialog.confirm({
                    title: '温馨提示',
                    message: '确定取消此订单吗？',
                  })
                  await $.start()
                  await apiOrderOrderCancel({
                    orderNo: order.orderNo,
                  })
                  await this.handleRefresh(order)
                  await $.success('取消成功')
                })
                break
              // 提醒发货
              case 3:
                await submit(async $ => {
                  await $.start()
                  await apiOrderOrderUrged({
                    orderNo: order.orderNo,
                  })
                  await this.handleRefresh(order)
                  await $.success('提醒发货成功')
                })
                break
              // 延长收货
              case 4:
                await submit(async $ => {
                  await $.start()
                  await apiOrderOrderDelayConfirm({
                    orderNo: order.orderNo,
                  })
                  await this.handleRefresh(order)
                  await $.success('延长收货成功')
                })
                break
              // 查看物流
              case 5:
                navigateTo('ExpressIndex', {
                  orderNo: order.orderNo,
                })
                break
              // 确认收货
              case 6:
                await submit(async $ => {
                  await Dialog.confirm({
                    title: '温馨提示',
                    message: '确认已经收到货物了吗？',
                    cancelButtonText: '暂未',
                    confirmButtonText: '确认收到',
                  })
                  await $.start()
                  await apiOrderOrderConfirm({
                    orderNo: order.orderNo,
                  })
                  await this.handleRefresh(order)
                  await $.success('确认收货成功')
                })
                break
              // 删除订单
              case 7:
                await submit(async $ => {
                  await Dialog.confirm({
                    title: '温馨提示',
                    message: '确定删除此订单吗？',
                  })
                  await $.start()
                  await apiOrderOrderDelete({
                    orderNo: order.orderNo,
                  })
                  await this.handleRefresh(order)
                  await $.success('删除成功')
                })
                break
              // 评价
              case 8:
              case 22:
                navigateTo('OrderComment', {
                  orderNo: order.orderNo,
                  isEvaluateAdd: action.type === 22,
                })
                break
              // 查看劵码
              case 9:
                navigateTo('BookOrderDetail', {
                  orderNo: order.orderNo,
                })

                break
              // 再来一单
              case 10:
                navigateTo('GoodsIndex', {
                  id: order.commodities[0].commodityId,
                })
                break

              // 拼团
              // 邀请好友
              case 11:
                GroupBuyingUtils.share({
                  goodsName: order.commodities[0].name,
                  goodsPrice: order.commodities[0].unitPrice,
                  goodsCover: order.commodities[0].pic,
                  groupOrderId: order.groupOrderId,
                  remainingCount: order.grouped ? 0 : order.differCount,
                })
                break
              // 支付并参团
              case 12:
                await submit(async $ => {
                  await $.start()
                  const payData = await apiGroupBuyingOrderPay({
                    orderId: order.orderNo,
                    payType: globalModel.state.payType as any,
                    openId: globalModel.state.openid,
                  })
                  await dcb.requestPayment({
                    provider: 'native',
                    showNativeResultPage: false,
                    params: payData,
                  })
                  await this.handleRefresh(order)
                  await $.success('支付成功')
                })
                break
              // 删除团单
              case 20:
                await submit(async $ => {
                  await Dialog.confirm({
                    title: '温馨提示',
                    message: '确定删除此订单吗？',
                  })
                  await $.start()
                  await apiGroupBuyingOrderDelete({
                    orderId: order.orderNo,
                  })
                  await this.handleRefresh(order)
                  await $.success('订单已删除')
                })
                break

              // 盲盒
              // 退款详情
              case 13:
                navigateTo('BoxRefundResult', {
                  orderId: order.orderId,
                })
                break
              // 查看详情
              case 14:
                submit(async $ => {
                  $.start()
                  const url = await apiBlindBoxOrderGetOrderUrl({
                    id: order.orderId,
                  })
                  dcb.navigateTo({
                    url: url,
                  })
                })
                break
              // 我要回收
              case 15:
                this.boxOrder.value = order
                this.showBoxRefundDialog.value = true
                break
              // 立即发货
              case 16:
                this.boxOrder.value = order
                this.showBoxDeliveryDialog.value = true
                break
              // 开盲盒
              case 17:
                const page: any = [
                  '8aaa997193dd9242019429cee3de0027',
                ].includes(order.activityId)
                  ? 'BoxOpen_2025'
                  : 'BoxOpen'
                navigateTo(page, {
                  id: order.boxId,
                  orderId: order.orderId,
                  fromOrderList: true,
                })
                break

              // 配送
              // 提醒接单
              case 18:
                await submit(async $ => {
                  await $.start()
                  await apiOrderOrderUrged({
                    orderNo: order.orderNo,
                  })
                  await this.handleRefresh(order)
                  await $.success('提醒接单成功')
                })
                break
              // 申请售后
              case 19:
                navigateTo('AfterSalesRequestSubmit', {
                  orderNo: order.orderNo,
                  fromInstantDelivery: true,
                })
                break

              // 兑换商品
              case 21:
                navigateTo('ExchangeIndex', {
                  id: order.commodities[0].commodityId,
                  orderNo: order.orderNo,
                })
                break
              // 查看评价
              case 23:
                navigateTo('UserComment')
                break
              // 评价审核中
              case 24:
                Toast('评价正在审核中！')
                break

              // 出示自提码
              case 25:
                nextTick(() => {
                  ;(ctx.$refs as any).OrderSelfpickShowCode.show()
                })
                break

              default:
                break
            }
          }
        },
      })

      handleLoad = ({ pageNumber }: any) => {
        return apiOrderBigOrderList({
          keyWord: this.keyword.value,
          pageIndex: pageNumber,
          pageSize: 10,
          beginTime: this.dateRange.value[0],
          endTime: this.dateRange.value[1],
          status: this.typeData.value[this.typeIndex.value].value,
        }).then(res => {
          // res.list![0].countDownTime!.openBoxTime = 74000 * 2000
          return res
        })
      }

      handleCheck = async (item: OrderItem) => {
        const {
          list: [newItem],
        } = await apiOrderBigOrderList({
          keyWord: this.keyword.value,
          pageIndex: 1,
          pageSize: 1,
          beginTime: this.dateRange.value[0],
          endTime: this.dateRange.value[1],
          status: this.typeData.value[this.typeIndex.value].value,
          orderNo: item.orderNo,
          saleAfterId: item.saleAfterId,
        }).then(asRequiredDeep)
        return newItem
      }

      handleRefresh = async (item: OrderItem) => {
        await this.waterfall.checkRecord(item.orderNo, 1500)
      }
    },
)
